import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { combineAll, DcBaseComponent } from '@datachain/ui-sdk/common';
import {
	AppModalService,
	ModalData,
} from '@datachain/ui-sdk/components/app-modal';
import { Observable } from 'rxjs';

import { DcIcons } from '../../../ui/app-dc.icons';

export enum MediaAction {
	Delete = 'delete',
}

export interface IMediaActionModalData {
	mediaId: number | Array<number>;
	element: string;
	action: MediaAction;
}

@Component({
	selector: 'app-media-action-popup',
	templateUrl: './media-action-popup.component.html',
	styleUrls: ['./media-action-popup.component.scss'],
})
export class MediaActionPopupComponent<T extends IMediaActionModalData>
	extends DcBaseComponent
	implements OnInit
{
	public vo$!: Observable<{
		element: string;
		mediaId: number | Array<number>;
		isMultipleElement: boolean;
		action: MediaAction;
	}>;
	public confirmDeletion = false;

	protected readonly DcIcons = DcIcons;
	protected readonly MediaAction = MediaAction;
	public constructor(
		private readonly modalService: AppModalService,
		@Inject(MAT_DIALOG_DATA) public readonly modalData: ModalData & T
	) {
		super();
		this.cmpId = 'media-action';
	}

	public ngOnInit(): void {
		super.ngOnInit();
		this.vo$ = combineAll({
			element: this.modalData.element,
			isMultipleElement:
				Array.isArray(this.modalData.mediaId) && this.modalData.element === '',
			mediaId: this.modalData.mediaId,
			action: this.modalData.action,
		});
	}

	public confirmAction(): void {
		this.modalService.closeActiveModal({
			shouldLaunch: true,
		});
	}
}
